import { useQuery } from "react-query";
import { getCommissionRemittance } from "../../../../actions/Utilities/CommissionRemittance";

export const useCommissionRemittance = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetCommissionRemittance",
    getCommissionRemittance,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
